// Constants
const FONTS = [
    { name: 'Arial', family: 'Arial, sans-serif' },
    { name: 'Times', family: '"Times New Roman", serif' },
    { name: 'Roboto', family: 'Roboto, sans-serif' },
    { name: 'Open Sans', family: '"Open Sans", sans-serif' },
    { name: 'Montserrat', family: 'Montserrat, sans-serif' },
    { name: 'Lato', family: 'Lato, sans-serif' },
    { name: 'Poppins', family: 'Poppins, sans-serif' },
    { name: 'Helvetica', family: 'Helvetica, sans-serif' },
    { name: 'Georgia', family: 'Georgia, serif' },
    { name: 'Verdana', family: 'Verdana, sans-serif' }
];

const COLORS = [
    { name: 'Black', value: '#000000' },
    { name: 'White', value: '#FFFFFF' },
    { name: 'Red', value: '#FF0000' },
    { name: 'Blue', value: '#0000FF' },
    { name: 'Green', value: '#00FF00' },
    { name: 'Yellow', value: '#FFFF00' },
    { name: 'Purple', value: '#800080' },
    { name: 'Orange', value: '#FFA500' },
    { name: 'Pink', value: '#FFC0CB' },
    { name: 'Gray', value: '#808080' }
];

const SPECIAL_CHARS = {
    '.': '<dot>',
    ',': '<comma>',
    '?': '<question>',
    '!': '<exclamation>',
    '@': '<at>',
    '#': '<hash>',
    '$': '<dollar>',
    '%': '<percent>',
    '&': '<ampersand>',
    '*': '<asterisk>',
    '(': '<lparen>',
    ')': '<rparen>',
    '-': '<hyphen>',
    '_': '<underscore>',
    '+': '<plus>',
    '=': '<equals>',
    '<': '<lt>',
    '>': '<gt>',
    '/': '<slash>',
    '\'': '<quote>',
    '"': '<dquote>',
    '\\': '<backslash>',
    ':': '<colon>',
    ';': '<semicolon>',
    '{': '<lbrace>',
    '}': '<rbrace>',
    '[': '<lbracket>',
    ']': '<rbracket>',
    '|': '<pipe>',
    '`': '<backtick>',
    '~': '<tilde>',
    '^': '<caret>'
};


const CHARSETS = {
    // Latin basic characters
    ENGLISH: [
        'A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z',
        'a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z',
        '0','1','2','3','4','5','6','7','8','9', 
        '.', ',', '?', '!', '@', '#', '$', '%', '&', '*', '(', ')', '-', '_', '+', '=', '<', '>', '/',
        "'", '"', '\\', ':', ';', '{', '}', '[', ']', '|', '`', '~', '^'
    ] ,



    // Vietnamese characters
    VIETNAMESE: [
        // Uppercase
        'A','Ă','Â','Á','Ắ','Ấ','À','Ằ','Ầ','Ả','Ẳ','Ẩ','Ã','Ẵ','Ẫ','Ạ','Ặ','Ậ',
        'B',
        'C',
        'D','Đ',
        'E','Ê','É','Ế','È','Ề','Ẻ','Ể','Ẽ','Ễ','Ẹ','Ệ',
        'F',
        'G',
        'H',
        'I','Í','Ì','Ỉ','Ĩ','Ị',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O','Ô','Ơ','Ó','Ố','Ớ','Ò','Ồ','Ờ','Ỏ','Ổ','Ở','Õ','Ỗ','Ỡ','Ọ','Ộ','Ợ',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U','Ư','Ú','Ứ','Ù','Ừ','Ủ','Ử','Ũ','Ữ','Ụ','Ự',
        'V',
        'W',
        'X',
        'Y','Ý','Ỳ','Ỷ','Ỹ','Ỵ',
        'Z',
        // Lowercase
        'a','ă','â','á','ắ','ấ','à','ằ','ầ','ả','ẳ','ẩ','ã','ẵ','ẫ','ạ','ặ','ậ',
        'b',
        'c',
        'd','đ',
        'e','ê','é','ế','è','ề','ẻ','ể','ẽ','ễ','ẹ','ệ',
        'f',
        'g',
        'h',
        'i','í','ì','ỉ','ĩ','ị',
        'j',
        'k',
        'l',
        'm',
        'n',
        'o','ô','ơ','ó','ố','ớ','ò','ồ','ờ','ỏ','ổ','ở','õ','ỗ','ỡ','ọ','ộ','ợ',
        'p',
        'q',
        'r',
        's',
        't',
        'u','ư','ú','ứ','ù','ừ','ủ','ử','ũ','ữ','ụ','ự',
        'v',
        'w',
        'x',
        'y','ý','ỳ','ỷ','ỹ','ỵ',
        'z',
        // Numbers and special characters
        '0','1','2','3','4','5','6','7','8','9',
        '.', ',', '?', '!', '@', '#', '$', '%', '&', '*',
        '(', ')', '-', '_', '+', '=', '<', '>', '/',
        "'", '"', '\\', ':', ';', '{', '}', '[', ']',
        '|', '`', '~', '^'
    ],

    // French keyboard characters
    FRENCH: [
        'A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z',
        'a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z',
        'À','Â','Æ','Ç','É','È','Ê','Ë','Î','Ï','Ô','Œ','Ù','Û','Ü','Ÿ',
        'à','â','æ','ç','é','è','ê','ë','î','ï','ô','œ','ù','û','ü','ÿ',
        '0','1','2','3','4','5','6','7','8','9',
        '.', ',', '?', '!', '@', '#', '$', '%', '&', '*', '(', ')', '-', '_', '+', '=', '<', '>', '/',
        "'", '"', '\\', ':', ';', '{', '}', '[', ']', '|', '`', '~', '^'
    ],

    // German keyboard characters
    GERMAN: [
        'A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z',
        'a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z',
        'Ä','Ö','Ü','ẞ','ä','ö','ü','ß',
        '0','1','2','3','4','5','6','7','8','9', 
        '.', ',', '?', '!', '@', '#', '$', '%', '&', '*', '(', ')', '-', '_', '+', '=', '<', '>', '/',
        "'", '"', '\\', ':', ';', '{', '}', '[', ']', '|', '`', '~', '^'
    ] ,

    // Spanish keyboard characters
    SPANISH: [
        'A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z',
        'a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z',
        'Á','É','Í','Ó','Ú','Ñ','Ü','á','é','í','ó','ú','ñ','ü',
        '0','1','2','3','4','5','6','7','8','9', 
        '.', ',', '?', '!', '@', '#', '$', '%', '&', '*', '(', ')', '-', '_', '+', '=', '<', '>', '/',
        "'", '"', '\\', ':', ';', '{', '}', '[', ']', '|', '`', '~', '^'
    ] ,

    // Basic Hiragana and Katakana characters
    JAPANESE: [
        'あ','い','う','え','お',
        'か','き','く','け','こ',
        'さ','し','す','せ','そ',
        'た','ち','つ','て','と',
        'な','に','ぬ','ね','の',
        'は','ひ','ふ','へ','ほ',
        'ま','み','む','め','も',
        'や','ゆ','よ',
        'ら','り','る','れ','ろ',
        'わ','を','ん',
        'ア','イ','ウ','エ','オ',
        'カ','キ','ク','ケ','コ',
        'サ','シ','ス','セ','ソ',
        'タ','チ','ツ','テ','ト',
        'ナ','ニ','ヌ','ネ','ノ',
        'ハ','ヒ','フ','ヘ','ホ',
        'マ','ミ','ム','メ','モ',
        'ヤ','ユ','ヨ',
        'ラ','リ','ル','レ','ロ',
        'ワ','ヲ','ン',
        '゛','゜','ー','、','。'
    ],

    // Basic Hangul characters
    KOREAN: [
        'ㄱ','ㄴ','ㄷ','ㄹ','ㅁ','ㅂ','ㅅ','ㅇ','ㅈ','ㅊ','ㅋ','ㅌ','ㅍ','ㅎ',
        'ㅏ','ㅑ','ㅓ','ㅕ','ㅗ','ㅛ','ㅜ','ㅠ','ㅡ','ㅣ',
        '가','나','다','라','마','바','사','아','자','차','카','타','파','하',
        '<dot>','<comma>','<question>','<exclamation>'
    ],

    // Common Chinese characters
    CHINESE: [
        '的','一','是','不','了','人','我','在','有','他',
        '这','为','之','大','来','以','个','中','上','们',
        '时','你','说','生','国','年','着','就','那','和',
        '要','她','出','也','得','里','后','自','以','会',
        '家','可','下','而','过','天','去','能','对','小',
        '多','然','于','心','学','么','之','都','好','看',
        '起','发','当','没','成','只','如','事','把','还',
        '用','第','样','道','想','作','种','开','美','总',
        '从','无','情','己','面','最','作'
    ],

    // Common emoji
    EMOJI: [
        '😀','😃','😄','😁','😅','😂','🤣','😊','😇','🙂','🙃','😉','😌','😍','🥰',
        '😘','😗','😙','😚','😋','😛','😝','😜','🤪','🤨','🧐','🤓','😎','🤩','🥳',
        '😏','😒','😞','😔','😟','😕','🙁','☹️','😣','😖','😫','😩','🥺','😢','😭',
        '😤','😠','😡','🤬','🤯','😳','🥵','🥶','😱','😨','😰','😥','😓','🤗','🤔',
        '🤭','🤫','🤥','😶','😐','😑','😬','🙄','😯','😦','😧','😮','😲','🥱','😴',
        '🤤','😪','😵','🤐','🥴','🤢','🤮','🤧','😷','🤒','🤕','🤑','🤠','😈','👿',
        '👹','👺','🤡','💩','👻','💀','☠️','👽','👾','🤖','🎃','😺','😸','😹','😻',
        '😼','😽','🙀','😿','😾','❤️','🧡','💛','💚','💙','💜','🖤','🤍','🤎','💔',
        '❣️','💕','💞','💓','💗','💖','💘','💝'
    ],

    // Chat emoji
    EMOJI_CHAT: [
        '👍','👎','👌','✌️','🤞','🤟','🤘','👊','✊','🤛','🤜','🤚','👋','🤙','💪',
        '🦾','🖕','✍️','🙏','🦶','🦵','🦿','💄','💋','👄','🦷','👅','👂','🦻','👃',
        '👣','👁️','👀','🧠','🗣️','👤','👥','👶','👧','🧒','👦','👩','🧑','👨','👩‍🦱',
        '🧑‍🦱','👨‍🦱','👩‍🦰','🧑‍🦰','👨‍🦰','👱‍♀️','👱','👱‍♂️','👩‍🦳','🧑‍🦳','👨‍🦳',
        '👩‍🦲','🧑‍🦲','👨‍🦲','🧔','👵','🧓','👴','👲','👳‍♀️','👳','👳‍♂️','🧕','👮‍♀️',
        '👮','👮‍♂️','👷‍♀️','👷','👷‍♂️','💂‍♀️','💂','💂‍♂️','🕵️‍♀️','🕵️','🕵️‍♂️','👩‍⚕️',
        '🧑‍⚕️','👨‍⚕️'
    ]

};

let currentScale = 1;
let strokeWidth = 1;
let strokeColor = '#000000';
let currentFont = 'Arial, sans-serif';
let currentCharset = 'ENGLISH';

// Khởi tạo Fabric canvas
let canvas;
let currentLetter;
let imgObj = null;

let generatedChars = [];  // Mảng lưu các ký tự đã tạo

// Thêm các biến toàn cục để theo dõi số lượng font
let userFontInfo = {
    count: 0,
    remaining: 5,
    fonts: []
};

function createLetter(letter, imgPattern) {
        // Tạo text với fontSize tạm thời
        var text = new fabric.Text(letter, {
            fontFamily: 'Arial',
            fill: imgPattern || '',
            stroke: strokeColor,
            strokeWidth: parseInt(strokeWidth),
            fontSize: 100, // Giá trị tạm thời
            selectable: false,
            controls: false,
            hasBorders: false,
            evented: false,
            originX: 'left',
            originY: 'top',
            left: canvas.getWidth() / 2,
            top: canvas.getHeight() / 2
        });

        // Tính toán tỷ lệ scale để fit vào canvas
        const padding = 0; // Khoảng cách lề
        const scaleX = (canvas.getWidth() - padding * 2) / text.width;
        const scaleY = (canvas.getHeight() - padding * 2) / text.height;
        const scale = Math.min(scaleX, scaleY);

        // Áp dụng fontSize mới
        text.set({
            fontSize: 100 * scale,
        });
        text.set({
            left: canvas.getWidth() / 2 - text.width  / 2,
            top: canvas.getHeight() / 2 - text.height * 1.1  / 2 
        });
        console.log('Creating letter:', {
            letter: letter,
            hasPattern: !!imgPattern,
            fontSize: 100 * scale,
            width: text.width,
            height: text.height,
            canvasWidth: canvas.getWidth(),
            canvasHeight: canvas.getHeight(),
            calculatedPosition: {
                left: canvas.getWidth() / 2 - text.width / 2,
                top: canvas.getHeight() / 2 - text.height / 2
            }
        });

        return text;
    }

function updateLayout() {
    // Cập nhật chiều cao của design-container
    const controlsHeight = $('.controls-container').outerHeight();
    document.documentElement.style.setProperty('--controls-height', controlsHeight + 'px');
    
    // Cập nhật kích thước canvas
    const container = $('.design-container');
    canvas.setWidth(container.width());
    canvas.setHeight(container.height());

    // Tạo và thêm chữ mới nếu chưa có
    if (!currentLetter) {
        currentLetter = createLetter('A');
        canvas.add(currentLetter);
    } else {
        // Nếu đã có chữ, cập nhật vị trí và kích thước
        const text = currentLetter.text;
        canvas.remove(currentLetter);
        currentLetter = createLetter(text);
        canvas.add(currentLetter);
    }

    canvas.renderAll();
}

// Hàm cập nhật fill cho chữ
function updateLetterFill() {
    if (imgObj && currentLetter) {
        // 1) Tính boundingBoxWidth, boundingBoxHeight cho ảnh đã xoay
        const angleInRadians = (imgObj.angle || 0) * Math.PI / 180;
        const cos = Math.cos(angleInRadians);
        const sin = Math.sin(angleInRadians);

        const boundingBoxWidth = imgObj.width * imgObj.scaleX * Math.abs(cos) + imgObj.height * imgObj.scaleY * Math.abs(sin);
        const boundingBoxHeight = imgObj.width * imgObj.scaleX * Math.abs(sin) + imgObj.height * imgObj.scaleY * Math.abs(cos);

        // 2) Tạo canvas tạm
        const tempCanvas = document.createElement('canvas');
        tempCanvas.width = boundingBoxWidth;
        tempCanvas.height = boundingBoxHeight;
        const ctx = tempCanvas.getContext('2d');

        // 3) Transform để vẽ ảnh xoay lên canvas tạm
        ctx.save();
        ctx.translate(tempCanvas.width / 2, tempCanvas.height / 2);
        ctx.rotate(angleInRadians);
        ctx.translate(
            -(imgObj.width * imgObj.scaleX / 2),
            -(imgObj.height * imgObj.scaleY / 2)
        );

        const imgElement = imgObj.getElement();
        ctx.drawImage(
            imgElement, 
            0, 
            0, 
            imgObj.width * imgObj.scaleX, 
            imgObj.height * imgObj.scaleY
        );
        ctx.restore();

        const imgCenterX = imgObj.left + (imgObj.width * imgObj.scaleX * cos - imgObj.height * imgObj.scaleY * sin) / 2;
        const imgCenterY = imgObj.top + (imgObj.width * imgObj.scaleX * sin + imgObj.height * imgObj.scaleY * cos) / 2;

        // 4) Tính offset để pattern khớp với vị trí trên chữ
        const rawOffsetX = imgCenterX - boundingBoxWidth / 2 - currentLetter.left;
        const rawOffsetY = imgCenterY - boundingBoxHeight / 2 - currentLetter.top;

        const imgPattern = new fabric.Pattern({
            source: tempCanvas,
            repeat: 'no-repeat',
            offsetX: rawOffsetX,
            offsetY: rawOffsetY
        });

        currentLetter.set('fill', imgPattern);
        canvas.renderAll();
    }
}

function initializeCanvas() {
    const designContainer = $('.design-container');
    canvas = new fabric.Canvas('letterCanvas', {
        width: designContainer.width(),
        height: designContainer.height(),
        backgroundColor: 'white',
        selection: false
    });

    // Cập nhật xử lý resize
    $(window).resize(updateLayout);
    
    // Cập nhật layout lần đầu
    setTimeout(updateLayout, 0);
}

function initializeControls() {
    // Initialize stroke width slider
    const strokeWidthSlider = $('.stroke-width-slider');
    const sizeValue = $('.size-value');

    strokeWidthSlider.on('input', function() {
        const value = parseInt(this.value);
        sizeValue.text(value);
        strokeWidth = value;
        if (currentLetter) {
            currentLetter.set('strokeWidth', value);
            canvas.renderAll();
        }
    });

    // Initialize photo button
    const photoButton = $('.nav-button.right');
    photoButton.text('🖼️');
    
    // Thêm tooltip help
    function showHelpTooltip() {
        const tooltip = $('<div>')
            .addClass('help-tooltip')
            .text('Click here to add patterns or images')
            .insertAfter(photoButton);

        // Định vị tooltip
        const buttonRect = photoButton[0].getBoundingClientRect();
        tooltip.css({
            top: buttonRect.top + buttonRect.height/2 - tooltip.height()/2,
            right: window.innerWidth - buttonRect.left + 20
        });

        // Tự động ẩn tooltip sau 5 giây
        setTimeout(() => {
            tooltip.fadeOut(500, function() {
                $(this).remove();
            });
        }, 5000);

        // Ẩn tooltip khi click vào button
        photoButton.one('click', () => {
            tooltip.remove();
        });
    }

    // Hiển thị tooltip sau khi trang load
    setTimeout(showHelpTooltip, 1000);

    photoButton.on('click', function() {
        openAddPatternModal();
    });


    // Initialize back button
    const backButton = $('.nav-button.left');
    backButton.on('click', function() {
        window.history.back();
    });

    // Initialize collections
    createFontCollection();
    createStrokeCollection();
    createCharsetCollection();

    // Initialize generate button
    $('.generate-button').on('click', generateFont);

    // Ngăn chặn gesture zoom
    document.addEventListener('gesturestart', function(e) {
        e.preventDefault();
    });

    document.addEventListener('gesturechange', function(e) {
        e.preventDefault();
    });

    document.addEventListener('gestureend', function(e) {
        e.preventDefault();
    });
}

function createFontCollection() {
    const fontCollection = $('#fontCollection');
    FONTS.forEach(font => {
        const item = $('<div>')
            .addClass('collection-item')
            .css('fontFamily', font.family)
            .text('Aa')
            .attr('title', font.name);
        
        if (font.family === currentFont) {
            item.addClass('active');
        }
        
        item.on('click', () => {
            fontCollection.find('.active').removeClass('active');
            item.addClass('active');
            
            currentFont = font.family;
            if (currentLetter) {
                currentLetter.set('fontFamily', font.family);
                canvas.renderAll();
            }
        });
        
        fontCollection.append(item);
    });
}

function createStrokeCollection() {
    const strokeCollection = $('#strokeCollection');
    COLORS.forEach(color => {
        const item = $('<div>')
            .addClass('collection-item')
            .css('backgroundColor', color.value)
            .attr('title', color.name);
        
        if (color.value === strokeColor) {
            item.addClass('active');
        }
        
        item.on('click', () => {
            strokeCollection.find('.active').removeClass('active');
            item.addClass('active');
            
            strokeColor = color.value;
            if (currentLetter) {
                currentLetter.set('stroke', color.value);
                canvas.renderAll();
            }
        });
        
        strokeCollection.append(item);
    });
}

function createCharsetCollection() {
    const charsetCollection = $('#charsetCollection');
    Object.entries(CHARSETS).forEach(([name, chars]) => {
        const item = $('<div>')
            .addClass('collection-item')
            .text(name)
            .attr('title', chars.map(getCharFromName).join(''));
        
        if (name === currentCharset) {
            item.addClass('active');
        }
        
        item.on('click', () => {
            charsetCollection.find('.active').removeClass('active');
            item.addClass('active');
            
            currentCharset = name;
            // Lấy ký tự gốc của ký tự đầu tiên
            const firstChar = getCharFromName(chars[0]);
            
            // Cập nhật currentLetter với ký tự gốc
            if (currentLetter) {
                currentLetter.set('text', firstChar);
                canvas.renderAll();
            }
        });
        
        charsetCollection.append(item);
    });
}


function generateFont() {
    clearLastSavedFont();
    if (!currentLetter || !imgObj) {
        alert('Please add an image and select a letter first');
        return;
    }

    const charset = CHARSETS[currentCharset];
    if (!charset) {
        alert('Please select a charset first');
        return;
    }

    // Reset mảng generatedChars
    generatedChars = [];
    const charPromises = [];

    // Tạo container cho kết quả
    const resultContainer = $('<div>').addClass('result-container').html(`
        <div class="result-content">
            <div class="result-header">
                <div class="result-title-row">
                    <div class="result-title">Generated Font</div>
                    <button class="save-font-btn">
                        <span class="btn-icon">💾</span>
                        <span class="btn-text">Save Font</span>
                    </button>
                    <button class="close-btn">✕</button>
                </div>
                <div class="result-actions">
                    <button class="design-btn">
                        <span class="btn-icon">✏️</span>
                        <span class="btn-text">Design</span>
                    </button>
                    <button class="download-btn" disabled>
                        <span class="btn-icon">⏳</span>
                        <span class="btn-text">Generating...</span>
                    </button>
                    <button class="download-zip-btn">
                        <span class="btn-icon">📦</span>
                        <span class="btn-text">Download Font Zip</span>
                    </button>
                    <button class="shop-btn">
                        <span class="btn-icon">🛍️</span>
                        <span class="btn-text">Shop</span>
                    </button>
                </div>
            </div>
            <div class="result-grid"></div>
        </div>
    `);

    // Thêm xử lý cho nút Design
    resultContainer.find('.design-btn').on('click', () => {
        // Kiểm tra xem font đã được lưu chưa
        const fontSaved = localStorage.getItem('lastSavedFontId');
        
        if (!fontSaved) {
            // Hiển thị thông báo yêu cầu lưu font
            const message = $('<div>').addClass('celebration-message warning').html(`
                <div class="celebration-title">Save Required</div>
                <div class="celebration-text">
                    Please save your font before proceeding to design.<br>
                    <button class="save-now-btn" style="
                        margin-top: 10px;
                        padding: 8px 16px;
                        background: #007AFF;
                        color: white;
                        border: none;
                        border-radius: 5px;
                        cursor: pointer;
                    ">Save Now</button>
                </div>
            `);

            // Thêm xử lý cho nút Save Now
            message.find('.save-now-btn').on('click', function() {
                message.remove();
                // Nén dữ liệu trước khi lưu
                const compressedChars = generatedChars.map(item => ({
                    char: item.char,
                    originalChar: item.originalChar,
                    image_data: compressImageData(item.image_data)
                }));
                showSaveFontDialog(compressedChars);
            });

            $('body').append(message);

            // Tự động ẩn thông báo sau 5 giây nếu không click Save Now
            setTimeout(() => {
                if (message.is(':visible')) {
                    message.css({'animation': 'messageOut 0.5s ease forwards'});
                    setTimeout(() => message.remove(), 500);
                }
            }, 5000);

            return;
        }

        // Nếu font đã được lưu, chuyển đến trang design
        window.open('/pages/design', '_blank');
    });

    // Thêm xử lý cho nút Shop
    resultContainer.find('.shop-btn').on('click', () => {
        window.open('https://shop.skeyy.com', '_blank');
    });

    // Thêm xử lý cho nút Download Font Zip
    resultContainer.find('.download-zip-btn').on('click', () => {
        downloadFontZip(generatedChars);
    });

    // Thêm xử lý nút save font
    resultContainer.find('.save-font-btn').on('click', function() {
        if (window.customer && window.customer.isLoggedIn) {
            // Đã đăng nhập, hiển thị dialog save font
            showSaveFontDialog(generatedChars);
        } else {
            // Chưa đăng nhập, hiển thị thông báo yêu cầu đăng nhập
            const loginMessage = $('<div>').addClass('celebration-message').html(`
                <div class="celebration-title">Login Required</div>
                <div class="celebration-text">
                    Please login to save your font.<br>
                    <a href="/account/login" class="login-link">Login now</a>
                </div>
            `);
            $('body').append(loginMessage);
            setTimeout(() => {
                loginMessage.css({'animation': 'messageOut 0.5s ease forwards'});
                setTimeout(() => loginMessage.remove(), 500);
            }, 3000);
        }
    });

    // Cập nhật style cho dialog
    const style = $('<style>').text(`
        .result-container {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0,0,0,0.5);
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 1000;
            opacity: 0;
            animation: fadeIn 0.3s ease forwards;
        }

        .result-content {
            background: white;
            padding: 30px;
            border-radius: 20px;
            width: 90%;
            max-width: 900px;
            max-height: 85vh;
            overflow-y: auto;
            transform: translateY(20px);
            opacity: 0;
            animation: slideUp 0.4s ease 0.1s forwards;
            box-shadow: 0 10px 30px rgba(0,0,0,0.2);
        }

        @keyframes fadeIn {
            from { opacity: 0; }
            to { opacity: 1; }
        }

        @keyframes slideUp {
            from {
                transform: translateY(20px);
                opacity: 0;
            }
            to {
                transform: translateY(0);
                opacity: 1;
            }
        }

        .result-header {
            display: flex;
            flex-direction: column;
            gap: 15px;
            margin-bottom: 20px;
            padding: 0 10px;
        }

        .result-title-row {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        .result-title {
            font-size: 24px;
            font-weight: bold;
            color: #333;
        }

        .result-actions {
            display: flex;
            gap: 10px;
            justify-content: flex-end;
        }

        .design-btn {
            background: #007AFF;
            color: white;
            border: none;
            border-radius: 8px;
            padding: 8px 16px;
            font-size: 14px;
            cursor: pointer;
            display: flex;
            align-items: center;
            gap: 6px;
            transition: all 0.2s;
        }

        .design-btn:hover {
            background: #0066CC;
            transform: translateY(-1px);
        }

        .design-btn .btn-icon {
            font-size: 16px;
        }

        .download-btn {
            display: flex;
            align-items: center;
            gap: 8px;
            padding: 10px 20px;
            border: none;
            border-radius: 8px;
            background: #007AFF;
            color: white;
            font-size: 15px;
            font-weight: 500;
            cursor: pointer;
            transition: all 0.2s;
        }

        .download-btn:hover:not(:disabled) {
            background: #0066CC;
            transform: translateY(-1px);
        }

        .download-btn:disabled {
            opacity: 0.6;
            cursor: not-allowed;
        }

        .btn-icon {
            font-size: 18px;
        }

        .close-btn {
            width: 36px;
            height: 36px;
            border: none;
            border-radius: 50%;
            background: #FF3B30;
            color: white;
            font-size: 18px;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: all 0.2s;
        }

        .close-btn:hover {
            background: #FF453A;
            transform: rotate(90deg);
        }

        .result-grid {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
            gap: 20px;
            padding: 10px;
        }

        .result-item {
            position: relative;
            aspect-ratio: 1;
            background: #f8f8f8;
            border-radius: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 15px;
            box-shadow: 0 2px 8px rgba(0,0,0,0.05);
            transition: all 0.2s;
            opacity: 0;
            animation: fadeInUp 0.3s ease forwards;
            cursor: pointer;
        }

        .result-item .original-char {
            position: absolute;
            bottom: 8px;
            right: 8px;
            font-size: 14px;
            color: #999;
            opacity: 0.6;
        }

        .result-item:hover {
            transform: translateY(-3px);
            box-shadow: 0 4px 12px rgba(0,0,0,0.1);
        }

        .result-item img {
            max-width: 100%;
            max-height: 100%;
            object-fit: contain;
        }

        @keyframes fadeInUp {
            from {
                opacity: 0;
                transform: translateY(10px);
            }
            to {
                opacity: 1;
                transform: translateY(0);
            }
        }

        /* Custom scrollbar */
        .result-content::-webkit-scrollbar {
            width: 8px;
        }

        .result-content::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 4px;
        }

        .result-content::-webkit-scrollbar-thumb {
            background: #888;
            border-radius: 4px;
        }

        .result-content::-webkit-scrollbar-thumb:hover {
            background: #666;
        }
    `);

    $('head').append(style);
    $('body').append(resultContainer);

    const resultGrid = resultContainer.find('.result-grid');

    // Thêm animation delay cho từng result-item
    charset.forEach((charName, index) => {
        const promise = new Promise((resolve) => {
            const charCanvas = new fabric.Canvas(null, {
                width: canvas.width,
                height: canvas.height,
                backgroundColor: 'transparent'
            });

            // Chuyển đổi tên ký tự thành ký tự gốc để hiển thị
            const originalChar = getCharFromName(charName);

            // Tạo chữ mới với ký tự gốc
            const letter = new fabric.Text(originalChar, {
                left: currentLetter.left,
                top: currentLetter.top,
                fontSize: currentLetter.fontSize,
                fontFamily: currentLetter.fontFamily,
                originX: currentLetter.originX,
                originY: currentLetter.originY,
                stroke: currentLetter.stroke,
                strokeWidth: currentLetter.strokeWidth,
                width: currentLetter.width,
                height: currentLetter.height,
                scaleX: currentLetter.scaleX,
                scaleY: currentLetter.scaleY,
                angle: currentLetter.angle
            });

            // Tạo pattern từ ảnh hiện tại
            const angleInRadians = (imgObj.angle || 0) * Math.PI / 180;
            const cos = Math.cos(angleInRadians);
            const sin = Math.sin(angleInRadians);

            const boundingBoxWidth = imgObj.width * imgObj.scaleX * Math.abs(cos) + 
                                   imgObj.height * imgObj.scaleY * Math.abs(sin);
            const boundingBoxHeight = imgObj.width * imgObj.scaleX * Math.abs(sin) + 
                                    imgObj.height * imgObj.scaleY * Math.abs(cos);

            const tempCanvas = document.createElement('canvas');
            tempCanvas.width = boundingBoxWidth;
            tempCanvas.height = boundingBoxHeight;
            const ctx = tempCanvas.getContext('2d');

            ctx.save();
            ctx.translate(boundingBoxWidth / 2, boundingBoxHeight / 2);
            ctx.rotate(angleInRadians);
            ctx.translate(-imgObj.width * imgObj.scaleX / 2, -imgObj.height * imgObj.scaleY / 2);

            const imgElement = imgObj.getElement();
            ctx.drawImage(imgElement, 0, 0, imgObj.width * imgObj.scaleX, imgObj.height * imgObj.scaleY);
            ctx.restore();


            const imgCenterX = imgObj.left + (imgObj.width * imgObj.scaleX * cos - imgObj.height * imgObj.scaleY * sin) / 2;
            const imgCenterY = imgObj.top + (imgObj.width * imgObj.scaleX * sin + imgObj.height * imgObj.scaleY * cos) / 2;

            // 4) Tính offset để pattern khớp với vị trí trên chữ
            const rawOffsetX = imgCenterX - boundingBoxWidth / 2 - currentLetter.left;
            const rawOffsetY = imgCenterY - boundingBoxHeight / 2 - currentLetter.top;

            // Tạo pattern với cùng offset như currentLetter
            const imgPattern = new fabric.Pattern({
                source: tempCanvas,
                repeat: 'no-repeat',
                offsetX: rawOffsetX,
                offsetY: rawOffsetY
            });

            // Áp dụng pattern cho chữ
            letter.set('fill', imgPattern);
            charCanvas.add(letter);
            charCanvas.renderAll();

            // Trim canvas trước khi chuyển thành ảnh
            const trimmedCanvas = trimCanvas(charCanvas.toCanvasElement());
            if (trimmedCanvas) {
                // Thêm vào grid và mảng kết quả
                const resultItem = $('<div>')
                    .addClass('result-item')
                    .css('animation-delay', `${index * 0.05}s`)
                    .append($('<img>').attr('src', trimmedCanvas.toDataURL()))
                    .append($('<span>').addClass('original-char').text(originalChar))
                    .on('click', function() {
                        showDetail(originalChar, trimmedCanvas.toDataURL(), index);
                    });
                resultGrid.append(resultItem);

                generatedChars.push({
                    char: charName,
                    originalChar: getCharFromName(charName),
                    image_data: trimmedCanvas.toDataURL()
                });
            } else {
                // Nếu không có pixel không trong suốt, sử dụng canvas gốc
                const resultItem = $('<div>')
                    .addClass('result-item')
                    .css('animation-delay', `${index * 0.05}s`)
                    .append($('<img>').attr('src', charCanvas.toDataURL()));
                resultGrid.append(resultItem);

                generatedChars.push({
                    char: charName,
                    originalChar: getCharFromName(charName),
                    //dùng webp
                    image_data: charCanvas.toDataURL('image/webp')
                });
            }

            resolve();
        });

        charPromises.push(promise);
    });

    // Đợi tất cả các ký tự được tạo xong
    Promise.all(charPromises).then(() => {
        const compressedChars = generatedChars.map(item => {
            try {
                const compressedData = compressImageData(item.image_data);
                if (!compressedData) {
                    throw new Error(`Failed to compress image data for character: ${item.char}`);
                }

                return {
                    char: item.char,
                    originalChar: item.originalChar || item.char,
                    image_data: compressedData
                };
            } catch (e) {
                console.error('Error compressing character:', e);
                return null;
            }
        }).filter(Boolean);

        if (compressedChars.length === 0) {
            alert('No valid characters generated');
            return;
        }

        // showSaveFontDialog(compressedChars);
    });

    // Xử lý nút close
    resultContainer.find('.close-btn').on('click', () => {
        resultContainer.remove();
    });
}

// Thêm hàm trimCanvas để cắt bỏ phần trong suốt
function trimCanvas(canvas) {
    const ctx = canvas.getContext('2d');
    const pixels = ctx.getImageData(0, 0, canvas.width, canvas.height);
    const l = pixels.data.length;
    let left = canvas.width;
    let right = 0;

    // Tìm điểm trái nhất và phải nhất
    for (let i = 0; i < l; i += 4) {
        if (pixels.data[i + 3] !== 0) {  // Nếu pixel không trong suốt
            const x = (i / 4) % canvas.width;
            left = Math.min(left, x);
            right = Math.max(right, x);
        }
    }

    // Nếu không tìm thấy pixel không trong suốt
    if (left === canvas.width && right === 0) {
        return null;
    }

    // Thêm padding
    const padding = 20;
    left = Math.max(0, left - padding);
    right = Math.min(canvas.width, right + padding);

    const trimWidth = right - left;

    // Tạo canvas mới chỉ với phần cần thiết
    const trimmed = document.createElement('canvas');
    trimmed.width = trimWidth;
    trimmed.height = canvas.height;

    // Copy phần cần thiết sang canvas mới
    const trimmedCtx = trimmed.getContext('2d');
    trimmedCtx.drawImage(
        canvas,
        left, 0, trimWidth, canvas.height,
        0, 0, trimWidth, canvas.height
    );

    return trimmed;
}

// Thêm hàm tạo confetti với z-index cao hơn
function createConfetti() {
    const duration = 3000;
    const animationEnd = Date.now() + duration;
    const defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 2000 };

    // Tạo canvas cho confetti với z-index cao hơn
    const myCanvas = document.createElement('canvas');
    myCanvas.style.position = 'fixed';
    myCanvas.style.top = '0';
    myCanvas.style.left = '0';
    myCanvas.style.width = '100%';
    myCanvas.style.height = '100%';
    myCanvas.style.pointerEvents = 'none';
    myCanvas.style.zIndex = '2000';
    document.body.appendChild(myCanvas);

    const myConfetti = confetti.create(myCanvas, {
        resize: true,
        useWorker: true
    });

    function randomInRange(min, max) {
        return Math.random() * (max - min) + min;
    }

    (function frame() {
        const timeLeft = animationEnd - Date.now();
        const ticks = Math.max(200, 500 * (timeLeft / duration));

        // Tính toán cường độ dựa trên thời gian còn lại
        const particleCount = 7 * (timeLeft / duration);
        const spread = 55 * (timeLeft / duration);

        // Launch confetti from both sides with fading intensity
        myConfetti({
            particleCount: Math.floor(particleCount),
            angle: 60,
            spread: spread,
            origin: { x: 0, y: 0.7 },
            colors: ['#ff0000', '#00ff00', '#0000ff', '#ffff00', '#ff00ff'],
            ticks: ticks,
            gravity: 0.9,
            decay: 0.95,
            startVelocity: 30 * (timeLeft / duration)
        });

        myConfetti({
            particleCount: Math.floor(particleCount),
            angle: 120,
            spread: spread,
            origin: { x: 1, y: 0.7 },
            colors: ['#ff0000', '#00ff00', '#0000ff', '#ffff00', '#ff00ff'],
            ticks: ticks,
            gravity: 0.9,
            decay: 0.95,
            startVelocity: 30 * (timeLeft / duration)
        });

        // Keep launching until duration expires
        if (timeLeft > 0) {
            requestAnimationFrame(frame);
        } else {
            // Fade out remaining confetti
            setTimeout(() => {
                myCanvas.style.transition = 'opacity 1s ease-out';
                myCanvas.style.opacity = '0';
                setTimeout(() => {
                    myCanvas.remove();
                }, 1000);
            }, 100);
        }
    }());

    // Thêm celebration message
    const message = $('<div>').addClass('celebration-message').html(`
        <div class="celebration-title">🎉 SKEYY! </div>
        <div class="celebration-text">
            Your font has been generated successfully.<br>
        </div>
    `);

    $('body').append(message);

    // Xóa message đồng bộ với confetti
    setTimeout(() => {
        message.css({
            'animation': 'messageOut 0.5s ease forwards'
        });
        setTimeout(() => {
            message.remove();
        }, 500);
    }, duration - 500); // Bắt đầu ẩn trước khi confetti kết thúc 500ms
}

// Thêm hàm showDetail
function showDetail(char, imageData, index) {
    if (!generatedChars.length) {
        console.warn('No generated characters available');
        return;
    }

    const detailDialog = $('<div>').addClass('detail-dialog').html(`
        <div class="detail-content">
            <button class="detail-close">✕</button>
            <button class="detail-nav prev">◀</button>
            <button class="detail-nav next">▶</button>
            <div class="detail-image-container">
                <img src="${imageData}" class="detail-image">
            </div>
            <div class="detail-info">
                Generated Character
                <div class="detail-original">Original: ${char}</div>
            </div>
            <div class="detail-actions">
                <button class="download-btn">
                    <span class="btn-icon">⬇️</span>
                    <span class="btn-text">Download This Character</span>
                </button>
            </div>
        </div>
    `);

    $('body').append(detailDialog);

    let currentIndex = index;
    const totalChars = generatedChars.length;

    // Hàm cập nhật nội dung
    function updateContent(newIndex, direction = 'next') {
        const item = generatedChars[newIndex];
        const currentImage = detailDialog.find('.detail-image');
        const container = detailDialog.find('.detail-image-container');
        
        // Tạo ảnh mới
        const newImage = $('<img>')
            .addClass('detail-image')
            .attr('src', item.image_data)
            .css({
                opacity: 0,
                position: 'absolute'
            });

        // Thêm ảnh mới vào container trước khi thêm class animation
        container.append(newImage);

        // Đợi ảnh load xong để tránh giật
        newImage.on('load', function() {
            // Thêm class animation
            newImage.addClass(direction === 'next' ? 'slide-left-enter' : 'slide-right-enter');
            currentImage.addClass(direction === 'next' ? 'slide-left-exit' : 'slide-right-exit');

            // Xóa ảnh cũ sau khi animation kết thúc
            setTimeout(() => {
                currentImage.remove();
            }, 300);
        });

        // Cập nhật text
        detailDialog.find('.detail-original').text(`Original: ${item.originalChar || char}`);
        currentIndex = newIndex;
    }

    // Xử lý nút prev
    detailDialog.find('.detail-nav.prev').on('click', () => {
        const newIndex = (currentIndex - 1 + totalChars) % totalChars;
        updateContent(newIndex, 'prev');
    });

    // Xử lý nút next
    detailDialog.find('.detail-nav.next').on('click', () => {
        const newIndex = (currentIndex + 1) % totalChars;
        updateContent(newIndex, 'next');
    });

    // Xử lý swipe
    let touchStartX = 0;
    let touchEndX = 0;

    detailDialog.find('.detail-content').on('touchstart', (e) => {
        touchStartX = e.touches[0].clientX;
    });

    detailDialog.find('.detail-content').on('touchmove', (e) => {
        touchEndX = e.touches[0].clientX;
    });

    detailDialog.find('.detail-content').on('touchend', () => {
        const swipeThreshold = 50;
        const swipeDistance = touchEndX - touchStartX;

        if (Math.abs(swipeDistance) > swipeThreshold) {
            if (swipeDistance > 0) {
                // Swipe right -> prev
                const newIndex = (currentIndex - 1 + totalChars) % totalChars;
                updateContent(newIndex, 'prev');
            } else {
                // Swipe left -> next
                const newIndex = (currentIndex + 1) % totalChars;
                updateContent(newIndex, 'next');
            }
        }
    });

    // Xử lý phím mũi tên
    $(document).on('keydown.detail', (e) => {
        if (e.key === 'ArrowLeft') {
            const newIndex = (currentIndex - 1 + totalChars) % totalChars;
            updateContent(newIndex, 'prev');
        } else if (e.key === 'ArrowRight') {
            const newIndex = (currentIndex + 1) % totalChars;
            updateContent(newIndex, 'next');
        }
    });

    // Xử lý nút download
    detailDialog.find('.download-btn').on('click', () => {
        const link = document.createElement('a');
        link.href = imageData;
        link.download = `char_${char}.webp`;
        link.click();
    });

    // Xử lý nút close
    detailDialog.find('.detail-close').on('click', () => {
        detailDialog.fadeOut(300, function() {
            $(this).remove();
        });
    });

    // Đóng dialog khi click bên ngoài
    detailDialog.on('click', function(e) {
        if (e.target === this) {
            $(this).fadeOut(300, function() {
                $(this).remove();
            });
        }
    });
}

function showSaveFontDialog(compressedChars) {
    // Lấy customer ID
    const customerId = window.customer?.id;
    if (!customerId) {
        alert('Please log in to save fonts');
        return;
    }

    // Kiểm tra số lượng font từ dữ liệu đã lưu
    if (userFontInfo.count >= 5) {
        alert('You have reached the maximum limit of 5 fonts. Please delete some fonts to create new ones.');
        return;
    }

    // Tính tỷ lệ phần trăm fonts đã sử dụng
    const usedPercentage = userFontInfo.count * 20; // 20 percent cho mỗi font (max 5 fonts)

    // Tạo dialog
    const dialog = $(`
        <div class="save-font-dialog">
            <div class="dialog-header">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M12 2L2 7l10 5 10-5-10-5z"/>
                    <path d="M2 17l10 5 10-5"/>
                    <path d="M2 12l10 5 10-5"/>
                </svg>
                <h2>Save Your Font</h2>
            </div>
            <div class="dialog-content">
                <div class="font-limit-info">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
                    </svg>
                    <div class="limit-text">
                        <div>You have used ${userFontInfo.count} of 5 font slots</div>
                        <div class="font-limit-progress">
                            <div class="progress-bar" style="width: ${usedPercentage}%"></div>
                        </div>
                    </div>
                </div>
                
                <div class="form-group">
                    <label for="fontName">Font Name</label>
                    <input type="text" id="fontName" placeholder="Give your font a name" maxlength="50">
                </div>
                
                <div class="form-group">
                    <label for="fontDesc">Description (optional)</label>
                    <textarea id="fontDesc" placeholder="Add details about your font" maxlength="200"></textarea>
                </div>
                
                <div class="dialog-buttons">
                    <button class="dialog-btn cancel-btn">Cancel</button>
                    <button class="dialog-btn save-btn">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path>
                            <polyline points="17 21 17 13 7 13 7 21"></polyline>
                            <polyline points="7 3 7 8 15 8"></polyline>
                        </svg>
                        Save Font
                    </button>
                </div>
            </div>
        </div>
    `);

    // Xử lý nút save
    dialog.find('.save-btn').on('click', function() {
        const fontName = dialog.find('#fontName').val().trim();
        const description = dialog.find('#fontDesc').val().trim();

        if (!fontName) {
            alert('Please enter a font name');
            return;
        }

        const saveBtn = $(this);
        saveBtn.addClass('saving').prop('disabled', true);

        const processedFontData = compressedChars.map(char => {
            try {
                // Kiểm tra và xử lý dữ liệu ảnh
                if (typeof char.image_data !== 'string' || !char.image_data.includes('base64,')) {
                    console.error('Invalid image data format:', char);
                    return null;
                }

                // Đảm bảo chuyển đổi sang WebP nếu không phải định dạng WebP
                let imageData = char.image_data;
                if (!imageData.includes('data:image/webp;base64,')) {
                    // Chuyển đổi sang WebP
                    const img = new Image();
                    img.src = imageData;
                    
                    // Tạo canvas mới để chuyển đổi
                    const canvas = document.createElement('canvas');
                    const ctx = canvas.getContext('2d');
                    
                    // Đợi ảnh load xong
                    return new Promise((resolve) => {
                        img.onload = function() {
                            canvas.width = img.width;
                            canvas.height = img.height;
                            ctx.drawImage(img, 0, 0);
                            
                            // Chuyển sang WebP
                            const webpData = canvas.toDataURL('image/webp', 0.9);
                            
                            resolve({
                                char: char.char,
                                image_data: webpData
                            });
                        };
                        
                        img.onerror = function() {
                            console.error('Error loading image for conversion:', char.char);
                            resolve(null);
                        };
                    });
                }
                
                // Trả về nếu đã là WebP
                return {
                    char: char.char,
                    image_data: imageData
                };
            } catch (e) {
                console.error('Error processing character:', e);
                return null;
            }
        });

        // Đợi tất cả promises hoàn thành
        Promise.all(processedFontData).then(results => {
            const validResults = results.filter(char => char !== null);
            
            if (validResults.length === 0) {
                alert('No valid characters to save');
                saveBtn.removeClass('saving').prop('disabled', false);
                return;
            }
            
            // Gửi request lưu font
            saveFontToServer(fontName, description, customerId, validResults)
            .then(data => {
                if (data.success === false) {
                    alert(data.error);
                    saveBtn.removeClass('saving').prop('disabled', false);
                    return;
                }
                
                // Cập nhật thông tin font sau khi lưu thành công
                userFontInfo.count = data.font_count;
                userFontInfo.remaining = data.remaining;
                
                localStorage.setItem('lastSavedFontId', data.id);
                
                // Hiển thị thông báo thành công với hiệu ứng confetti
                confetti({
                    particleCount: 100,
                    spread: 70,
                    origin: { y: 0.6 }
                });
                
                // Tự động generate font file OTF
                generateFontFile(data.id, fontName, validResults, dialog);
                
                showFontLimitNotification(data);
            })
            .catch(error => {
                console.error('Error saving font:', error);
                alert('Failed to save font: ' + error.message);
                saveBtn.removeClass('saving').prop('disabled', false);
            });
        })
        .catch(error => {
            console.error('Error processing font data:', error);
            alert('Failed to process font data: ' + error.message);
            saveBtn.removeClass('saving').prop('disabled', false);
        });
    });

    // Xử lý nút cancel
    dialog.find('.cancel-btn').on('click', () => dialog.remove());

    // Thêm dialog vào body
    $('body').append(dialog);
    
    // Focus vào input đầu tiên
    setTimeout(() => {
        dialog.find('#fontName').focus();
    }, 100);
}

function saveFontToServer(fontName, description, customerId, characters) {
    return fetch('https://i.wahup.com/api/fonts/', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            name: fontName,
            description: description,
            customer_id: customerId,
            characters: characters
        })
    })
    .then(response => response.json())
    .then(data => {
        if (data.success === false) {
            alert(data.error);
            throw new Error(data.error);
        }
        
        // Hiển thị thông báo về số font còn lại
        if (data.remaining !== undefined) {
            showFontLimitNotification(data);
        }
        
        return data;
    });
}

// Generate OTF font file from character images
async function generateFontFile(fontId, fontName, characters, dialog) {
    try {
        // Create progress section
        const progressSection = $(`
            <div class="font-generation-progress">
                <div class="progress-step active" data-step="prepare">
                    <div class="step-icon">⚙️</div>
                    <span>Preparing character data...</span>
                </div>
                <div class="progress-step" data-step="upload">
                    <div class="step-icon">📤</div>
                    <span>Uploading to server...</span>
                </div>
                <div class="progress-step" data-step="generate">
                    <div class="step-icon">🔨</div>
                    <span>Generating OTF color font file...</span>
                </div>
                <div class="progress-step" data-step="download">
                    <div class="step-icon">⬇️</div>
                    <span>Preparing download...</span>
                </div>
            </div>
        `);
        
        dialog.find('.dialog-content').append(progressSection);
        
        // Show generating button
        const generateBtn = $('<button>')
            .addClass('font-generate-btn generating')
            .css({
                'width': '100%',
                'margin-top': '15px'
            })
            .html(`
                <div style="display: flex; align-items: center; justify-content: center; gap: 8px;">
                    <div class="generate-animation"></div>
                    <span>Generating OTF Color Font...</span>
                </div>
            `);
        
        dialog.find('.dialog-buttons').append(generateBtn);
        
        // Step 1: Prepare data
        await new Promise(resolve => setTimeout(resolve, 800));
        updateProgressStep('prepare', true);
        updateProgressStep('upload', false);

        // Step 2: Prepare data for font generation
        const fontData = {
            font_id: fontId,
            font_name: fontName,
            characters: characters.map(char => ({
                unicode: char.char,
                image_data: char.image_data,
                original_char: char.originalChar || char.char
            }))
        };

        await new Promise(resolve => setTimeout(resolve, 500));
        updateProgressStep('upload', true);
        updateProgressStep('generate', false);

        // Step 3: Call Django endpoint to generate OTF
        const response = await fetch('https://i.wahup.com/generate-font/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(fontData)
        });

        updateProgressStep('generate', true);
        updateProgressStep('download', false);

        let result;
        try {
            result = await response.json();
        } catch (parseError) {
            // If can't parse JSON, try to read as text for debugging  
            try {
                const responseText = await response.text();
                console.error('Response parsing error:', parseError);
                console.error('Response text:', responseText);
                throw new Error(`Server response error: ${response.status} - ${responseText.substring(0, 300)}...`);
            } catch(textError) {
                console.error('Could not read response as text either:', textError);
                throw new Error(`Server response error: ${response.status} - Unable to read response`);
            }
        }

        if (!response.ok) {
            throw new Error(result.error || `HTTP error! status: ${response.status}`);
        }
        
        if (result.success) {
            // Step 4: Complete and prepare download
            updateProgressStep('download', true);
            
            // Update button to show success
            generateBtn.removeClass('generating').addClass('success').html(`
                <div style="display: flex; align-items: center; justify-content: center; gap: 8px;">
                    <span>✅</span>
                    <span>Download Font File (${(result.file_size/1024).toFixed(1)}KB)</span>
                </div>
            `).off('click').on('click', () => {
                // Download the font file
                const link = document.createElement('a');
                link.href = result.download_url;
                const fileExt = result.download_url.split('.').pop();
                link.download = `${fontName}.${fileExt}`;
                link.click();
            });

            // Show success message
            const successMsg = $('<div>')
                .css({
                    'color': '#28a745',
                    'font-size': '14px',
                    'margin-top': '10px',
                    'text-align': 'center',
                    'font-weight': '500'
                })
                .html('🎉 Font generated successfully! Click button above to download.');
            
            dialog.find('.dialog-content').append(successMsg);

            // Auto-download after 2 seconds
            setTimeout(() => {
                const link = document.createElement('a');
                link.href = result.download_url;
                const fileExt = result.download_url.split('.').pop();
                link.download = `${fontName}.${fileExt}`;
                link.click();
                
                // Update button text after auto-download
                generateBtn.html(`
                    <div style="display: flex; align-items: center; justify-content: center; gap: 8px;">
                        <span>📁</span>
                        <span>Download Again</span>
                    </div>
                `);
                
                // Close dialog after delay
                setTimeout(() => {
                    dialog.remove();
                }, 3000);
            }, 2000);

        } else {
            throw new Error(result.error || 'Font generation failed');
        }

    } catch (error) {
        console.error('Error generating font file:', error);
        
        // Update progress to show error
        dialog.find('.progress-step.active').removeClass('active').addClass('error');
        
        // Update button to show error
        const errorBtn = dialog.find('.font-generate-btn');
        errorBtn.removeClass('generating').addClass('error').html(`
            <div style="display: flex; align-items: center; justify-content: center; gap: 8px;">
                <span>❌</span>
                <span>Font Generation Failed</span>
            </div>
        `);

        // Show detailed error message
        const errorMsg = $('<div>')
            .css({
                'color': '#dc3545',
                'font-size': '13px',
                'margin-top': '10px',
                'padding': '10px',
                'background': '#f8d7da',
                'border': '1px solid #f5c6cb',
                'border-radius': '5px',
                'text-align': 'center'
            })
            .html(`<strong>Error:</strong> ${error.message}<br><small>Please try again or contact support.</small>`);
        
        dialog.find('.dialog-content').append(errorMsg);
        
        // Add retry button
        const retryBtn = $('<button>')
            .addClass('dialog-btn')
            .css({
                'background': '#6c757d',
                'color': 'white',
                'margin-top': '10px',
                'width': '100%'
            })
            .text('Try Again')
            .on('click', () => {
                // Remove error elements and retry
                dialog.find('.font-generation-progress, .font-generate-btn, div[style*="color: #dc3545"]').remove();
                generateFontFile(fontId, fontName, characters, dialog);
            });
        
        dialog.find('.dialog-buttons').append(retryBtn);
        
        // Close dialog after delay
        setTimeout(() => {
            dialog.remove();
        }, 8000);
    }
}

// Helper function to update progress steps
function updateProgressStep(stepName, completed) {
    const step = $(`.progress-step[data-step="${stepName}"]`);
    const allSteps = $('.progress-step');
    
    // Remove active class from all steps
    allSteps.removeClass('active');
    
    if (completed) {
        step.addClass('completed').removeClass('active');
        step.find('.step-icon').text('✅');
    } else {
        step.addClass('active').removeClass('completed');
    }
}

function showFontLimitNotification(data) {
    const message = `
        <div class="font-saved-notification">
            <h3>Font "${data.name}" saved successfully!</h3>
            <p>You have used ${data.font_count} of 5 font slots.</p>
            <p>Remaining: ${data.remaining} font slots</p>
            <div class="progress-bar">
                <div class="progress" style="width: ${data.font_count * 20}%"></div>
            </div>
            <button class="design-now-btn">Design Now</button>
        </div>
    `;
    
    const notification = $(`
        <div class="font-notification" style="
            position: fixed;
            bottom: 20px;
            right: 20px;
            background: white;
            padding: 15px 20px;
            border-radius: 5px;
            box-shadow: 0 2px 10px rgba(0,0,0,0.2);
            z-index: 1000;
            max-width: 300px;
            animation: slideIn 0.3s ease;
        ">
            ${message}
        </div>
    `);
    
    // Style cho progress bar
    notification.find('.progress-bar').css({
        'width': '100%',
        'height': '10px',
        'background': '#eee',
        'border-radius': '5px',
        'margin': '10px 0'
    });
    
    notification.find('.progress').css({
        'height': '100%',
        'background': '#007AFF',
        'border-radius': '5px'
    });
    
    notification.find('.design-now-btn').css({
        'background': '#007AFF',
        'color': 'white',
        'border': 'none',
        'padding': '8px 15px',
        'border-radius': '5px',
        'margin-top': '10px',
        'cursor': 'pointer'
    }).on('click', function() {
        window.location.href = '/pages/design';
    });
    
    $('body').append(notification);
    
    // Tự động ẩn sau 5 giây
    setTimeout(() => {
        notification.css('animation', 'slideOut 0.3s ease forwards');
        setTimeout(() => notification.remove(), 300);
    }, 5000);
}

// Thêm animation cho thông báo
$('<style>')
    .text(`
        @keyframes slideIn {
            from { transform: translateX(100%); opacity: 0; }
            to { transform: translateX(0); opacity: 1; }
        }
        @keyframes slideOut {
            from { transform: translateX(0); opacity: 1; }
            to { transform: translateX(100%); opacity: 0; }
        }
    `)
    .appendTo('head');

// Helper function to get CSRF token
function getCookie(name) {
    let cookieValue = null;
    if (document.cookie && document.cookie !== '') {
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();
            if (cookie.substring(0, name.length + 1) === (name + '=')) {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    }
    return cookieValue;
}

// Sửa lại hàm compressImageData để xử lý base64 an toàn hơn
function compressImageData(base64String) {
    try {
        // Kiểm tra xem chuỗi có đúng định dạng không
        if (!base64String || !base64String.includes('base64,')) {
            console.error('Invalid base64 string format');
            return null;
        }
        // Chỉ lấy phần data sau base64,
        return base64String.split('base64,')[1];
    } catch (e) {
        console.error('Error compressing image data:', e);
        return null;
    }
}

// Thêm hàm để nén dữ liệu base64
function decompressImageData(compressedData) {
    return `data:image/webp;base64,${compressedData}`;
}

// Sửa lại phần tải font khi cần
function loadGeneratedFont() {
    try {
        const chunksCount = parseInt(localStorage.getItem('fontChunksCount'));
        if (!chunksCount) return null;

        let compressedChars = [];
        
        // Ghép các chunk lại
        for (let i = 0; i < chunksCount; i++) {
            const chunk = JSON.parse(localStorage.getItem(`generatedFont_chunk_${i}`));
            compressedChars = compressedChars.concat(chunk);
        }

        // Khôi phục dữ liệu gốc
        return compressedChars.map(item => ({
            char: item.char,
            originalChar: item.originalChar,
            image_data: decompressImageData(item.image_data)
        }));
    } catch (e) {
        console.error('Error loading font:', e);
        return null;
    }
}

// Thêm hàm xóa font khỏi localStorage
function clearGeneratedFont() {
    try {
        const chunksCount = parseInt(localStorage.getItem('fontChunksCount'));
        if (!chunksCount) return;

        for (let i = 0; i < chunksCount; i++) {
            localStorage.removeItem(`generatedFont_chunk_${i}`);
        }
        localStorage.removeItem('fontChunksCount');
    } catch (e) {
        console.error('Error clearing font:', e);
    }
}

// Thêm hàm clear lastSavedFontId khi bắt đầu tạo font mới
function clearLastSavedFont() {
    localStorage.removeItem('lastSavedFontId');
}

// Thêm hàm tải thông tin font khi trang được tải
function loadUserFontInfo() {
    const customerId = window.customer?.id;
    if (!customerId) return;

    // Hiển thị loading indicator nếu cần
    fetch(`https://i.wahup.com/api/fonts/?customer_id=${customerId}`)
    .then(response => response.json())
    .then(data => {
        userFontInfo = {
            count: data.font_count || 0,
            remaining: data.remaining_fonts || 5 - (data.font_count || 0),
            fonts: data.fonts || []
        };
        console.log('User font info loaded:', userFontInfo);
    })
    .catch(error => {
        console.error('Error loading font info:', error);
    });
}

// Add Pattern Modal functionality
function openAddPatternModal() {
    console.log('Opening add pattern modal');
    
    // Create modal
    const modal = document.createElement('div');
    modal.className = 'pattern-add-modal';
    modal.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.5);
        z-index: 10001;
        display: flex;
        justify-content: center;
        align-items: center;
    `;
    
    modal.innerHTML = `
        <div style="background: white; border-radius: 8px; padding: 20px; max-width: 600px; width: 95%; max-height: 80vh; overflow-y: auto;">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px;">
                <h3 style="margin: 0; font-size: 18px; font-weight: 600;">Add Pattern</h3>
                <button class="pattern-add-close" style="border: none; background: none; font-size: 20px; cursor: pointer;">&times;</button>
            </div>
            
            <!-- Use Your Photo Button -->
            <div style="margin-bottom: 20px;">
                <button class="pattern-use-photo-btn" style="width: 100%; padding: 12px; background: #007bff; color: white; border: none; border-radius: 6px; font-size: 14px; cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 8px;">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
                        <circle cx="8.5" cy="8.5" r="1.5"/>
                        <polyline points="21,15 16,10 5,21"/>
                    </svg>
                    Use Your Photo
                </button>
                <input type="file" class="pattern-photo-input" accept="image/*" style="display: none;">
            </div>
            
            <!-- Search Box -->
            <div style="margin-bottom: 20px;">
                <div style="display: flex; gap: 8px;">
                    <input type="text" class="pattern-search" placeholder="Search patterns..." style="flex: 1; padding: 8px 12px; border: 1px solid #ddd; border-radius: 4px; font-size: 14px;">
                    <button class="pattern-search-btn" style="padding: 8px 16px; background: #007bff; color: white; border: none; border-radius: 4px; cursor: pointer;">Search</button>
                </div>
            </div>
            
            <!-- Category Tags -->
            <div class="pattern-category-tags" style="display: flex; flex-wrap: wrap; gap: 8px; margin-bottom: 20px;">
                <!-- Categories will be loaded here -->
            </div>
            
            <!-- Pattern Container -->
            <div class="pattern-container" style="position: relative; min-height: 320px;">
                <!-- Pattern Results -->
                <div class="pattern-results" style="display: grid; grid-template-columns: repeat(auto-fill, minmax(80px, 1fr)); gap: 10px; max-height: 300px; overflow-y: auto; min-height: 300px;">
                    <!-- Initial placeholder to prevent height jump -->
                    <div style="grid-column: 1 / -1; display: flex; align-items: center; justify-content: center; height: 300px; color: #ccc; font-size: 14px;">
                        Ready to load patterns...
                    </div>
                </div>
                
                <!-- Loading Overlay -->
                <div class="pattern-loading" style="display: none; position: absolute; top: 0; left: 0; width: 100%; height: 100%; background: rgba(255,255,255,0.9); z-index: 10; align-items: center; justify-content: center; flex-direction: column;">
                    <div style="display: inline-block; width: 20px; height: 20px; border: 3px solid #f3f3f3; border-top: 3px solid #007bff; border-radius: 50%; animation: spin 1s linear infinite;"></div>
                    <p style="margin: 10px 0 0 0; color: #666;">Loading patterns...</p>
                </div>
            </div>
            
            <!-- Pagination Controls -->
            <div class="pattern-pagination" style="display: none; justify-content: center; align-items: center; gap: 10px; margin-top: 15px; padding: 10px 0; border-top: 1px solid #eee;">
                <button class="pattern-prev-btn" style="padding: 6px 12px; border: 1px solid #ddd; background: white; border-radius: 4px; cursor: pointer; font-size: 12px;" disabled>← Previous</button>
                <span class="pattern-page-info" style="font-size: 12px; color: #666; min-width: 100px; text-align: center;">Page 1 of 1</span>
                <button class="pattern-next-btn" style="padding: 6px 12px; border: 1px solid #ddd; background: white; border-radius: 4px; cursor: pointer; font-size: 12px;" disabled>Next →</button>
            </div>
        </div>
    `;
    
    document.body.appendChild(modal);
    document.body.style.overflow = 'hidden';
    
    // Get elements
    const closeBtn = modal.querySelector('.pattern-add-close');
    const usePhotoBtn = modal.querySelector('.pattern-use-photo-btn');
    const photoInput = modal.querySelector('.pattern-photo-input');
    const searchInput = modal.querySelector('.pattern-search');
    const searchBtn = modal.querySelector('.pattern-search-btn');
    const categoryTags = modal.querySelector('.pattern-category-tags');
    const patternResults = modal.querySelector('.pattern-results');
    const loading = modal.querySelector('.pattern-loading');
    const pagination = modal.querySelector('.pattern-pagination');
    const prevBtn = modal.querySelector('.pattern-prev-btn');
    const nextBtn = modal.querySelector('.pattern-next-btn');
    const pageInfo = modal.querySelector('.pattern-page-info');
    
    let currentCategory = 'latest';
    let currentPage = 1;
    let currentSearch = '';
    
    // Close modal function
    function closeModal() {
        try {
            document.removeEventListener('keydown', escHandler);
            setTimeout(() => {
                try {
                    if (modal && modal.parentNode) {
                        document.body.removeChild(modal);
                    }
                    document.body.style.overflow = '';
                } catch (error) {
                    console.warn('Error removing modal:', error);
                }
            }, 10);
        } catch (error) {
            console.warn('Error in closeModal:', error);
        }
    }
    
    // Load categories
    async function loadCategories() {
        try {
            const response = await fetch('https://i.wahup.com/get-pattern-categories/');
            const categories = await response.json();
            
            // Add trending as default first
            const allCategories = [
                { name: 'latest', label: 'Latest' },
                { name: 'trending', label: 'Trending' },
                ...categories.map(cat => ({ name: cat.name.toLowerCase(), label: cat.name }))
            ];
            
            categoryTags.innerHTML = allCategories.map(cat => `
                <button class="pattern-category-btn" data-category="${cat.name}" style="padding: 6px 12px; border: 2px solid ${cat.name === 'latest' ? '#007bff' : '#ddd'}; background: ${cat.name === 'latest' ? '#007bff' : 'white'}; color: ${cat.name === 'latest' ? 'white' : '#333'}; border-radius: 20px; font-size: 12px; cursor: pointer; white-space: nowrap;">
                    ${cat.label}
                </button>
            `).join('');
            
            // Add category click handlers
            categoryTags.querySelectorAll('.pattern-category-btn').forEach(btn => {
                btn.addEventListener('click', () => {
                    // Update button states
                    categoryTags.querySelectorAll('.pattern-category-btn').forEach(b => {
                        b.style.background = 'white';
                        b.style.color = '#333';
                        b.style.borderColor = '#ddd';
                    });
                    
                    btn.style.background = '#007bff';
                    btn.style.color = 'white';
                    btn.style.borderColor = '#007bff';
                    
                    currentCategory = btn.getAttribute('data-category');
                    loadPatterns(currentCategory, '', 1);
                });
            });
            
        } catch (error) {
            console.error('Error loading categories:', error);
            // Fallback categories
            categoryTags.innerHTML = `
                <button class="pattern-category-btn" data-category="latest" style="padding: 6px 12px; border: 2px solid #007bff; background: #007bff; color: white; border-radius: 20px; font-size: 12px; cursor: pointer;">Latest</button>
                <button class="pattern-category-btn" data-category="trending" style="padding: 6px 12px; border: 2px solid #ddd; background: white; color: #333; border-radius: 20px; font-size: 12px; cursor: pointer;">Trending</button>
            `;
        }
    }
    
    // Load patterns with pagination
    async function loadPatterns(category, searchTerm = '', page = 1) {
        // Show loading overlay without clearing content
        loading.style.display = 'flex';
        pagination.style.display = 'none';
        
        // Update current state
        currentCategory = category;
        currentSearch = searchTerm;
        currentPage = page;
        
        try {
            let url = 'https://i.wahup.com/search-pattern/';
            const params = new URLSearchParams();
            
            if (category) {
                params.append('category', category);
            }
            if (searchTerm) {
                params.append('q', searchTerm);
            }
            params.append('page', page.toString());
            params.append('per_page', '20');
            
            if (params.toString()) {
                url += '?' + params.toString();
            }
            
            const response = await fetch(url);
            const data = await response.json();
            
            // Hide loading overlay
            loading.style.display = 'none';
            
            if (data.patterns && data.patterns.length > 0) {
                patternResults.innerHTML = data.patterns.map(pattern => `
                    <div class="pattern-item" data-url="${pattern.url}" style="cursor: pointer; border-radius: 6px; overflow: hidden; border: 2px solid transparent; transition: border-color 0.2s;">
                        <img src="${pattern.thumb_url || pattern.url}" alt="${pattern.name || 'Pattern'}" style="width: 100%; height: 80px; object-fit: cover; display: block;">
                    </div>
                `).join('');
                
                // Update pagination controls
                if (data.pagination && data.pagination.total_pages > 1) {
                    pagination.style.display = 'flex';
                    pageInfo.textContent = `Page ${data.pagination.current_page} of ${data.pagination.total_pages}`;
                    
                    // Update buttons
                    prevBtn.disabled = !data.pagination.has_previous;
                    nextBtn.disabled = !data.pagination.has_next;
                    
                    prevBtn.style.opacity = data.pagination.has_previous ? '1' : '0.5';
                    nextBtn.style.opacity = data.pagination.has_next ? '1' : '0.5';
                    prevBtn.style.cursor = data.pagination.has_previous ? 'pointer' : 'not-allowed';
                    nextBtn.style.cursor = data.pagination.has_next ? 'pointer' : 'not-allowed';
                } else {
                    pagination.style.display = 'none';
                }
                
                // Add click handlers for patterns
                patternResults.querySelectorAll('.pattern-item').forEach(item => {
                    item.addEventListener('click', () => {
                        const url = item.getAttribute('data-url');
                        addPatternFromUrl(url);
                        closeModal();
                    });
                    
                    item.addEventListener('mouseenter', () => {
                        item.style.borderColor = '#007bff';
                    });
                    
                    item.addEventListener('mouseleave', () => {
                        item.style.borderColor = 'transparent';
                    });
                });
            } else {
                patternResults.innerHTML = '<p style="text-align: center; color: #666; padding: 20px;">No patterns found</p>';
                pagination.style.display = 'none';
            }
            
        } catch (error) {
            console.error('Error loading patterns:', error);
            loading.style.display = 'none';
            patternResults.innerHTML = '<p style="text-align: center; color: #dc3545; padding: 20px;">Error loading patterns</p>';
            pagination.style.display = 'none';
        }
    }
    
    // Add pattern from URL
    function addPatternFromUrl(url) {
        fabric.Image.fromURL(url, function(img) {
            // Xóa ảnh cũ nếu có
            if (imgObj) {
                canvas.remove(imgObj);
            }

            // Tính toán tỷ lệ scale để ảnh fit vào canvas
            const padding = 40;
            const scaleX = (canvas.getWidth() - padding * 2) / img.width;
            const scaleY = (canvas.getHeight() - padding * 2) / img.height;
            const scale = Math.min(scaleX, scaleY);

            // Cấu hình ảnh mới với scale đã tính
            imgObj = img.set({
                left: canvas.getWidth() / 2 - (img.width * scale) / 2,
                top: canvas.getHeight() / 2 - (img.height * scale) / 2,
                originX: 'left',
                originY: 'top',
                opacity: 0.4,
                selectable: true,
                scaleX: scale,
                scaleY: scale
            });

            // Thêm ảnh vào canvas
            canvas.add(imgObj);
            canvas.sendToBack(imgObj);
            updateLetterFill();

            // Thêm các event listeners
            imgObj.on('moving', updateLetterFill);
            imgObj.on('scaling', updateLetterFill);
            imgObj.on('rotating', updateLetterFill);

            canvas.renderAll();
        }, { crossOrigin: 'anonymous' });
    }
    
    // Event handlers
    prevBtn.addEventListener('click', () => {
        if (currentPage > 1) {
            loadPatterns(currentCategory, currentSearch, currentPage - 1);
        }
    });
    
    nextBtn.addEventListener('click', () => {
        loadPatterns(currentCategory, currentSearch, currentPage + 1);
    });
    
    // Search functionality
    let searchTimeout;
    searchInput.addEventListener('input', () => {
        clearTimeout(searchTimeout);
        searchTimeout = setTimeout(() => {
            const searchTerm = searchInput.value.trim();
            loadPatterns(currentCategory, searchTerm, 1);
        }, 500);
    });
    
    searchBtn.addEventListener('click', () => {
        const searchTerm = searchInput.value.trim();
        loadPatterns(currentCategory, searchTerm, 1);
    });
    
    searchInput.addEventListener('keypress', (e) => {
        if (e.key === 'Enter') {
            const searchTerm = searchInput.value.trim();
            loadPatterns(currentCategory, searchTerm, 1);
        }
    });
    
    // Use photo functionality
    usePhotoBtn.addEventListener('click', () => {
        photoInput.click();
    });
    
    photoInput.addEventListener('change', (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = (e) => {
                addPatternFromUrl(e.target.result);
                closeModal();
            };
            reader.readAsDataURL(file);
        }
        photoInput.value = '';
    });
    
    // Close handlers
    closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        closeModal();
    });

    modal.addEventListener('click', (e) => {
        if (e.target === modal) {
            e.preventDefault();
            e.stopPropagation();
            closeModal();
        }
    });
    
    // ESC key
    const escHandler = (e) => {
        if (e.key === 'Escape') {
            closeModal();
            document.removeEventListener('keydown', escHandler);
        }
    };
    document.addEventListener('keydown', escHandler);
    
    // Initialize
    loadCategories();
    loadPatterns('latest', '', 1);
}

// Sửa hàm khởi tạo để gọi loadUserFontInfo
$(document).ready(function() {
    initializeCanvas();
    initializeControls();
    
    // Tải thông tin font nếu người dùng đã đăng nhập
    if (window.customer?.isLoggedIn) {
        loadUserFontInfo();
    }
});

// Cập nhật hàm finishFontGeneration để kiểm tra font count và hiển thị thông báo
function finishFontGeneration(compressedChars) {
    clearGeneratedFont(); // Xóa dữ liệu font tạm thời
    clearLastSavedFont(); // Xóa ID font đã lưu trước đó
    
    // Hiển thị thông báo hoàn thành
    const message = $('<div>').addClass('celebration-message').html(`
        <div class="celebration-title">Font Generated!</div>
        <div class="celebration-text">
            Your font has been generated with ${compressedChars.length} characters!<br>
            <button class="save-font-btn" style="
                margin-top: 10px;
                padding: 8px 16px;
                background: #007AFF;
                color: white;
                border: none;
                border-radius: 5px;
                cursor: pointer;
            ">Save Font</button>
        </div>
    `);
    
    $('body').append(message);
    
    // Trigger confetti effect
    confetti({
        particleCount: 100,
        spread: 70,
        origin: { y: 0.6 }
    });
    
    // Auto hide message after delay
    setTimeout(() => {
        if (message.is(':visible')) {
            message.css('animation', 'messageOut 0.5s ease forwards');
            setTimeout(() => message.remove(), 500);
        }
    }, 5000);
    
    // Add event listener to save button
    message.find('.save-font-btn').on('click', function() {
        message.remove();
        showSaveFontDialog(compressedChars);
    });
    
    // Lưu font đã tạo vào localStorage
    try {
        // Chia thành các chunk để tránh lỗi localStorage quá lớn
        const chunkSize = 20;
        const chunks = [];
        
        for (let i = 0; i < compressedChars.length; i += chunkSize) {
            chunks.push(compressedChars.slice(i, i + chunkSize));
        }
        
        // Lưu từng chunk
        chunks.forEach((chunk, index) => {
            localStorage.setItem(`generatedFont_chunk_${index}`, JSON.stringify(chunk));
        });
        
        // Lưu số lượng chunk
        localStorage.setItem('fontChunksCount', chunks.length);
    } catch (e) {
        console.error('Error saving font to localStorage:', e);
    }
    
    return compressedChars;
}

document.addEventListener('DOMContentLoaded', function() {
    const accountBtn = document.querySelector('.nav-button.account');
    const dropdown = document.querySelector('.account-dropdown');

    if (!accountBtn || !dropdown) return; // Kiểm tra xem các phần tử có tồn tại không

    // Toggle dropdown và class active khi click
    accountBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        this.classList.toggle('active');
        dropdown.style.display = this.classList.contains('active') ? 'block' : 'none';
    });

    // Đóng dropdown khi click bên ngoài
    document.addEventListener('click', function(e) {
        if (!accountBtn.contains(e.target)) {
            accountBtn.classList.remove('active');
            dropdown.style.display = 'none';
        }
    });

    // Ngăn dropdown đóng khi click vào nội dung dropdown
    dropdown.addEventListener('click', function(e) {
        e.stopPropagation();
    });
});

// Hàm chuyển đổi ký tự đặc biệt sang tên gọi
function getCharName(char) {
    return SPECIAL_CHARS[char] || char;
}

// Hàm chuyển đổi tên gọi sang ký tự đặc biệt
function getCharFromName(name) {
    const char = Object.entries(SPECIAL_CHARS).find(([_, value]) => value === name)?.[0];
    return char || name;
}

// Hàm chuyển đổi ký tự thành Unicode code point (hex)
function getUnicodeHex(char) {
    if (typeof char !== 'string' || char.length === 0) {
        return '0020'; // Space character fallback
    }
    
    // Lấy ký tự đầu tiên và chuyển thành Unicode hex
    const codePoint = char.codePointAt(0);
    return codePoint.toString(16).toUpperCase().padStart(4, '0');
}

// Hàm tạo tên file an toàn từ ký tự
function getSafeFileName(char) {
    // Chỉ xử lý các ký tự bình thường A-Z, a-z, 0-9
    if (/^[a-zA-Z0-9]$/.test(char)) {
        return char;
    }
    
    // Tạm thời bỏ qua các ký tự đặc biệt
    return null;
}

// Hàm tạo và thêm file SVG
async function createAndAddSVG(imageData, safeFileName, pngFileName, svgsFolder) {
    return new Promise((resolve) => {
        // Tạo image element để lấy kích thước
        const img = new Image();
        img.onload = function() {
            const width = img.width;
            const height = img.height;
            
            // Tạo nội dung SVG
            const svgContent = `<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 ${width} ${height}">
  <image width="${width}" height="${height}" href="../imgs/${pngFileName}"/>
</svg>`;
            
            // Thêm file SVG vào folder
            svgsFolder.file(`${safeFileName}.svg`, svgContent);
            resolve();
        };
        
        img.onerror = function() {
            console.error(`Error loading image for SVG creation: ${safeFileName}`);
            // Tạo SVG với kích thước mặc định nếu không thể load image
            const svgContent = `<svg xmlns="http://www.w3.org/2000/svg" width="200" height="200" viewBox="0 0 200 200">
  <image width="200" height="200" href="../imgs/${pngFileName}"/>
</svg>`;
            svgsFolder.file(`${safeFileName}.svg`, svgContent);
            resolve();
        };
        
        img.src = imageData;
    });
}

// Hàm download font zip
async function downloadFontZip(generatedChars) {
    if (!generatedChars || generatedChars.length === 0) {
        alert('No characters to download');
        return;
    }
    
    try {
        // Tạo zip instance
        const zip = new JSZip();
        const imgsFolder = zip.folder('imgs');
        const svgsFolder = zip.folder('svgs');
        
        // Tạo array cho CSV content
        const csvContent = [];
        csvContent.push('filename,unicode'); // Header
        
        // Đếm số lượng xử lý để hiển thị progress
        let processedCount = 0;
        const totalCount = generatedChars.length;
        
        // Hiển thị progress
        const progressDialog = $(`
            <div style="
                position: fixed;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                background: white;
                padding: 30px;
                border-radius: 10px;
                box-shadow: 0 10px 30px rgba(0,0,0,0.3);
                z-index: 10000;
                text-align: center;
                min-width: 300px;
            ">
                <h3 style="margin: 0 0 20px 0; color: #333;">Creating Font Zip</h3>
                <div style="
                    width: 100%;
                    height: 10px;
                    background: #f0f0f0;
                    border-radius: 5px;
                    overflow: hidden;
                    margin-bottom: 15px;
                ">
                    <div class="zip-progress-bar" style="
                        height: 100%;
                        background: #28a745;
                        width: 0%;
                        transition: width 0.3s ease;
                    "></div>
                </div>
                <div class="zip-progress-text">Processing images and SVGs... 0/${totalCount}</div>
            </div>
        `);
        $('body').append(progressDialog);
        
        // Lọc và xử lý chỉ các ký tự bình thường
        const validChars = generatedChars.filter(charData => {
            const originalChar = charData.originalChar || getCharFromName(charData.char);
            return getSafeFileName(originalChar) !== null;
        });
        
        // Cập nhật tổng số ký tự hợp lệ
        const validTotalCount = validChars.length;
        progressDialog.find('.zip-progress-text').text(`Processing images and SVGs... 0/${validTotalCount}`);
        
        // Xử lý từng ký tự hợp lệ
        for (const charData of validChars) {
            try {
                const originalChar = charData.originalChar || getCharFromName(charData.char);
                const safeFileName = getSafeFileName(originalChar);
                const unicodeHex = getUnicodeHex(originalChar);
                
                // Chuyển đổi base64 thành blob
                const base64Data = charData.image_data.split(',')[1];
                const binaryData = atob(base64Data);
                const bytes = new Uint8Array(binaryData.length);
                
                for (let i = 0; i < binaryData.length; i++) {
                    bytes[i] = binaryData.charCodeAt(i);
                }
                
                // Xác định loại file từ base64 header
                let fileExtension = 'png'; // default
                if (charData.image_data.includes('data:image/webp')) {
                    fileExtension = 'webp';
                } else if (charData.image_data.includes('data:image/jpeg')) {
                    fileExtension = 'jpg';
                }
                
                // Tạo tên file với extension
                const fileName = `${safeFileName}.${fileExtension}`;
                
                // Thêm file PNG vào zip
                imgsFolder.file(fileName, bytes);
                
                // Tạo và thêm file SVG
                await createAndAddSVG(charData.image_data, safeFileName, fileName, svgsFolder);
                
                // Thêm vào CSV
                csvContent.push(`imgs/${fileName},${unicodeHex}`);
                
                // Cập nhật progress
                processedCount++;
                const progressPercent = (processedCount / validTotalCount) * 100;
                progressDialog.find('.zip-progress-bar').css('width', `${progressPercent}%`);
                progressDialog.find('.zip-progress-text').text(`Processing images and SVGs... ${processedCount}/${validTotalCount}`);
                
                // Để browser có thời gian cập nhật UI
                if (processedCount % 5 === 0) {
                    await new Promise(resolve => setTimeout(resolve, 10));
                }
                
            } catch (error) {
                console.error(`Error processing character ${charData.char}:`, error);
            }
        }
        
        // Kiểm tra nếu không có ký tự hợp lệ nào
        if (validChars.length === 0) {
            progressDialog.remove();
            alert('No valid characters (A-Z, a-z, 0-9) found to include in zip file.');
            return;
        }
        
        // Tạo file CSV
        const csvBlob = csvContent.join('\n');
        zip.file('glyphmap.csv', csvBlob);
        
        // Cập nhật progress để hiển thị đang tạo zip
        progressDialog.find('.zip-progress-text').text('Creating zip file...');
        
        // Tạo và download zip file
        const zipBlob = await zip.generateAsync({
            type: 'blob',
            compression: 'DEFLATE',
            compressionOptions: {
                level: 6
            }
        });
        
        // Download file
        const link = document.createElement('a');
        link.href = URL.createObjectURL(zipBlob);
        link.download = `font_${Date.now()}.zip`;
        link.click();
        
        // Cleanup
        URL.revokeObjectURL(link.href);
        progressDialog.remove();
        
        // Hiển thị thông báo thành công với số lượng ký tự
        const successMsg = $(`
            <div style="
                position: fixed;
                bottom: 20px;
                right: 20px;
                background: #28a745;
                color: white;
                padding: 15px 20px;
                border-radius: 5px;
                box-shadow: 0 2px 10px rgba(0,0,0,0.2);
                z-index: 10000;
                animation: slideIn 0.3s ease;
            ">
                ✅ Font zip downloaded! (${validChars.length} characters)
            </div>
        `);
        $('body').append(successMsg);
        
        setTimeout(() => {
            successMsg.css('animation', 'slideOut 0.3s ease forwards');
            setTimeout(() => successMsg.remove(), 300);
        }, 3000);
        
    } catch (error) {
        console.error('Error creating font zip:', error);
        
        // Xóa progress dialog nếu có lỗi
        $('.zip-progress-dialog').remove();
        
        alert('Error creating font zip: ' + error.message);
    }
}
